import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera',
template: templateSource || '',
    styles: [``],
})
export class PageKieraComponent implements OnInit {
    public typeSummary: any = {};
    public conditionSummary: any = {};
    public groupSummary: any[] = [];
    public memos: any[] = [];
    public newMemo: any = { title: '', content: '' };
    public showMemoModal: boolean = false;
    public editingMemo: any = null;
    public serverResources: any = null;
    public dragIndex: number = -1;

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadData();
        await this.service.render();
    }

    public async loadData() {
        const { code, data } = await wiz.call("summary");
        if (code === 200) {
            this.typeSummary = data.type_summary || {};
            this.conditionSummary = data.condition_summary || {};
            this.groupSummary = data.group_summary || [];
        }
        const res = await wiz.call("memos");
        if (res.code === 200) {
            this.memos = res.data || [];
        }
        await this.loadServerResources();
        await this.service.render();
    }

    public async loadServerResources() {
        const { code, data } = await wiz.call("server_resources");
        if (code === 200) {
            this.serverResources = data.resources;
        }
    }

    public get totalNodes() {
        return (this.typeSummary.ipmi || 0) + (this.typeSummary.mqtt || 0) + (this.typeSummary.others || 0);
    }

    public get totalCondition() {
        return (this.conditionSummary.normal || 0) + (this.conditionSummary.warning || 0) + (this.conditionSummary.off || 0);
    }

    public formatBytes(bytes: number): string {
        if (!bytes) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        let i = 0;
        let val = bytes;
        while (val >= 1024 && i < units.length - 1) {
            val /= 1024;
            i++;
        }
        return val.toFixed(1) + ' ' + units[i];
    }

    // === Memo CRUD ===
    public openMemoModal() {
        this.newMemo = { title: '', content: '' };
        this.editingMemo = null;
        this.showMemoModal = true;
    }

    public openEditMemo(memo: any) {
        this.editingMemo = memo;
        this.newMemo = { title: memo.title, content: memo.content };
        this.showMemoModal = true;
        this.service.render();
    }

    public async saveMemo() {
        if (!this.newMemo.title.trim() && !this.newMemo.content.trim()) return;
        if (this.editingMemo) {
            await wiz.call("memo_update", { id: this.editingMemo.id, data: JSON.stringify(this.newMemo) });
        } else {
            await wiz.call("memo_create", { data: JSON.stringify(this.newMemo) });
        }
        this.showMemoModal = false;
        this.editingMemo = null;
        await this.loadData();
    }

    public async deleteMemo(id: number) {
        if (!confirm(this.translate.instant('page.dashboard.confirm_delete_memo'))) return;
        const { code } = await wiz.call("memo_delete", { id });
        if (code === 200) await this.loadData();
    }

    // === Memo Drag & Drop Reorder ===
    public onDragStart(index: number) {
        this.dragIndex = index;
    }

    public onDragOver(event: DragEvent, index: number) {
        event.preventDefault();
    }

    public async onDrop(event: DragEvent, dropIndex: number) {
        event.preventDefault();
        if (this.dragIndex === dropIndex || this.dragIndex < 0) return;
        const item = this.memos.splice(this.dragIndex, 1)[0];
        this.memos.splice(dropIndex, 0, item);
        this.dragIndex = -1;
        const ids = this.memos.map((m: any) => m.id);
        await wiz.call("memo_reorder", { ids: JSON.stringify(ids) });
        await this.service.render();
    }

    public onDragEnd() {
        this.dragIndex = -1;
    }
}

export default PageKieraComponent;
